import { useRef, useState } from 'react'

import EditMenu from '../../../components/Dropdown/EditMenu'
import { db } from '../../../config/firebase';
import { doc, getDoc, deleteDoc, updateDoc } from 'firebase/firestore';
import { BiMessageAltEdit } from "react-icons/bi";
import { TbCopyCheck } from "react-icons/tb";
import { IoDocumentText } from "react-icons/io5";
import { FiDownload } from "react-icons/fi";
import ReactQuill from 'react-quill';
import './readQuill.css';

import { BsCopy } from "react-icons/bs";
import { BsClipboard } from "react-icons/bs";
import { BsTrash3 } from "react-icons/bs";

import { PiEyeClosedLight } from "react-icons/pi";
import { PiEyeClosedFill } from "react-icons/pi";
import { PiEyeClosedDuotone } from "react-icons/pi";
import { PiNotePencil } from "react-icons/pi";
import { RiShareForwardBoxLine } from "react-icons/ri";


import { BsBookmark } from "react-icons/bs";
import { BsBookmarkFill } from "react-icons/bs";
import { BsBookmarkPlus } from "react-icons/bs";
import { BsBookmarkDashFill } from "react-icons/bs";
import { HiReply } from "react-icons/hi";
import QuillEditor from './Editor';
import useOutsideCloser from '../../../custom hooks/clickOutsideCloser';



function Chat({ item, himself, date, timestamp, setClickedImg,
  setMediaMessage,
  setShowImagePopup, setReplyingToMessage,
  setMessageToBeDeletedId,
  bookmarkedBy,
  uid, setChats,
  handleForwardMessage,
  handleMessageCopy,
  setEditingMessageId
}) {
  const { displayName, message, id, deleted, edited, url,
    mediaType, documentName,
    replyingToId,
    replyingToDisplayName,
    replyToMessage,
    quillEditorEnable,
    isBookmarkedProp,
    isGURULoggedIn,
    isForwarded, } = item


  const [openWrapperMenu, setOpenWrapperMenu] = useState(false);
  const [isCopied, setIsCopied] = useState(false)
  const [enteredMessage, setEnteredMessage] = useState(message);
  const [menuDropdownOthers, setMenuDropdownOthers] = useState([
    {
      name: "Copy",
      icon: <BsCopy className='w-full h-full' />,
      onClick: () => { handleMessageCopy(message) },
    },
    {
      name: "Reply",
      icon: <HiReply className='w-full h-full' />,
      onClick: () => {
        var div = document.createElement("div");
        div.innerHTML = message.replace("<br>", " \n ");
        // console.log(message);
        setReplyingToMessage({ displayName, messageToDisplay: div.innerText, id, himself, message })
      },
    },
    {
      name: "Forward",
      icon: <RiShareForwardBoxLine className='w-full h-full' />,
      onClick: () => { handleForwardMessage(item) },
    },
    // {
    //   name: "Unread All",
    //   icon: <PiEyeClosedLight className='w-full h-full' />,
    //   onClick: () => { },
    // },
    // {
    //   name: "Read All",
    //   icon: <PiEyeClosedFill className='w-full h-full' />,
    //   onClick: () => { },
    // },
    // {
    //   name: "Read Some",
    //   icon: <PiEyeClosedDuotone className='w-full h-full' />,
    //   onClick: () => { },
    // },
    ,])
  const [menuDropdown, setMenuDropdown] = useState(isForwarded ?
    [
      {
        name: "Reply",
        icon: <HiReply className='w-full h-full' />,
        onClick: () => {
          var div = document.createElement("div");
          div.innerHTML = message.replace("<br>", " \n ");
          // console.log(message);
          setReplyingToMessage({ displayName, messageToDisplay: div.innerText, id, himself, message })
        },
      },
      {
        name: "Forward",
        icon: <RiShareForwardBoxLine className='w-full h-full' />,
        onClick: () => { handleForwardMessage(item) },
      },
      {
        name: "Copy",
        icon: <BsCopy className='w-full h-full' />,
        onClick: () => { handleMessageCopy(message) },
      },
      {
        name: "Delete",
        icon: <BsTrash3 className='w-full h-full' />,
        onClick: () => { setMessageToBeDeletedId(id) },
      },
      ,]
    :
    [
      {
        name: "Edit",
        icon: <PiNotePencil className='w-full h-full' />,
        onClick: () => { setEditingMessageId(id) },
      },
      {
        name: "Reply",
        icon: <HiReply className='w-full h-full' />,
        onClick: () => {
          var div = document.createElement("div");
          div.innerHTML = message.replace("<br>", " \n ");
          // console.log(message);
          setReplyingToMessage({ displayName, messageToDisplay: div.innerText, id, himself, message })
        },
      },
      {
        name: "Forward",
        icon: <RiShareForwardBoxLine className='w-full h-full' />,
        onClick: () => { handleForwardMessage(item) },
      },
      {
        name: "Copy",
        icon: <BsCopy className='w-full h-full' />,
        onClick: () => { handleMessageCopy(message) },
      },
      {
        name: "Delete",
        icon: <BsTrash3 className='w-full h-full' />,
        onClick: () => { setMessageToBeDeletedId(id) },
      },
      ,]
  )

  function remove(what, arr) {
    var found = arr.indexOf(what);

    if (found !== -1) {
      arr.splice(found, 1);
      return 1;
    }
    else return 0
  }

  const handleBookmarkMessage = async () => {
    let prevBookmark = bookmarkedBy;

    setChats((prev) => (prev.map((item) => {
      if (item.id === id) {

        if (!remove(uid, prevBookmark))
          prevBookmark.push(uid)
        // console.log(prevBookmark);

        return ({ ...item, bookmarkedBy: prevBookmark })
      }
      return (item);
    })))


    const docRef = doc(db, 'chats', id);

    try {
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        await updateDoc(docRef, {
          bookmarkedBy: prevBookmark,
        });
        console.log("Document successfully Edited: ",);
      } else {
        // console.log("DNE: ",);
      }

    } catch (error) {
      // console.error("Error adding document: ", error);
    }
  };


  function downloadURI(uri, name) {
    // console.log(name);
    var link = document.createElement("a");
    // If you don't know the name or want to use
    // the webserver default set name = ''
    link.setAttribute('download', name);
    link.setAttribute('target', "_blank");
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }


  return (
    <div id={id} className={`relative flex ${himself ? "justify-end" : "justify-start"} items-start`}>

      {!himself &&
        <div className="w-9 h-9 lg:w-9 lg:h-9 rounded-l-xl flex items-center justify-center bg-lightPrimary shadow-md">
        </div>
      }
      {/* {!himself && <img className="w-9 h-9 lg:w-9 lg:h-9 rounded-l-xl" src={profileImg ? profileImg : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"} alt="profile" />} */}

      <div className={`flex flex-col items-end min-w-[190px] md:min-w-[205px] max-w-[75%] leading-1.5 p-3 pt-2 border-gray-200 
      ${himself ? "rounded-b-xl rounded-l-xl bg-lightSecondary" : "rounded-b-xl rounded-r-xl bg-lightPrimary"}
      ${openWrapperMenu ? (himself ? "!rounded-l-none" : "!rounded-r-none") : ""}
      ${false ? "w-[75%]" : ""}
      dark:bg-gray-700`}>

        {/* ------------------------| TOP LINE: Timestamp, Name */}
        <div className="w-full flex justify-between">
          {himself && // RIGHTSIDE -->>
            <div className="flex items-center gap-2 md:gap-3" >
              {deleted ?
                <div></div> :
                <EditMenu menuData={[menuDropdownOthers, setMenuDropdownOthers]} wrapperData={[openWrapperMenu, setOpenWrapperMenu]} himself={himself} />
              }
              <span className="text-xs md:text-xs font-normal text-gray-500 dark:text-gray-400">{timestamp} &nbsp;{date}</span>
              {bookmarkedBy.includes(uid) ?
                <div className="group cursor-pointer">
                  <BsBookmarkFill
                    onClick={handleBookmarkMessage}
                    className={`h-3 w-3 group-hover:hidden text-headPrimary /hover:text-headPrimary dark:text-white  `} />
                  <BsBookmarkDashFill
                    onClick={handleBookmarkMessage}
                    className={`h-3 w-3 hidden group-hover:block text-headPrimary /hover:text-headPrimary dark:text-white  `} />
                </div>
                :
                <div className="group cursor-pointer">
                  <BsBookmark
                    onClick={handleBookmarkMessage}
                    className={`h-3 w-3 group-hover:hidden text-gray-400 hover:text-headPrimary dark:text-white  `} />
                  <BsBookmarkPlus
                    onClick={handleBookmarkMessage}
                    className={`h-3 w-3 hidden group-hover:block text-gray-400 hover:text-headPrimary dark:text-white  `} />
                </div>
              }
              {isForwarded && <RiShareForwardBoxLine className="h-3 w-3 text-gray-400 dark:text-white" />}
              {edited && <BiMessageAltEdit className="h-3 w-3 text-gray-400 dark:text-white" />}
              {isCopied && <TbCopyCheck className="h-3 w-3 text-gray-400 dark:text-white" />}
            </div>
          }

          <div className={`flex items-center space-x-2`}>
            <span className={`text-base font-semibold text-gray-900 dark:text-white absolute top-2 ${!himself ? "left-2" : "right-2"}`}>{displayName}</span>
          </div>

          {!himself && //GREEN CHATS
            <div className="flex items-center gap-2 md:gap-3" >
              {isCopied && <TbCopyCheck className="h-3 w-3 text-gray-400 dark:text-white" />}
              {edited && <BiMessageAltEdit className="h-3 w-3 text-gray-400 dark:text-white" />}
              {isForwarded && <RiShareForwardBoxLine className="h-3 w-3 text-gray-400 dark:text-white" />}
              {bookmarkedBy.includes(uid) ?
                <div className="group cursor-pointer">
                  <BsBookmarkFill
                    onClick={handleBookmarkMessage}
                    className={`h-3 w-3 group-hover:hidden text-headPrimary /hover:text-headPrimary dark:text-white  `} />
                  <BsBookmarkDashFill
                    onClick={handleBookmarkMessage}
                    className={`h-3 w-3 hidden group-hover:block text-headPrimary /hover:text-headPrimary dark:text-white  `} />
                </div>
                :
                <div className="group cursor-pointer">
                  <BsBookmark
                    onClick={handleBookmarkMessage}
                    className={`h-3 w-3 group-hover:hidden text-gray-400 hover:text-headPrimary dark:text-white  `} />
                  <BsBookmarkPlus
                    onClick={handleBookmarkMessage}
                    className={`h-3 w-3 hidden group-hover:block text-gray-400 hover:text-headPrimary dark:text-white  `} />
                </div>
              }

              <span className="text-xs font-normal text-gray-500 dark:text-gray-400">{date} &nbsp;{timestamp}</span>
              {deleted ?
                <div></div> :
                <EditMenu menuData={[menuDropdown, setMenuDropdown]} wrapperData={[openWrapperMenu, setOpenWrapperMenu]} himself={himself} />
              }
            </div>
          }
        </div>

        {replyingToId &&
          <a href={`#${replyingToId}`}
            className={`relative w-full rounded-lg bg-gray-50 hover:bg-gray-100 ${false ? "/bg-lightSecondary" : "/bg-lightPrimary"} border border-gray-300 truncate mt-1 flex h-fit`}>

            <div className={`absolute left-0 top-0 bottom-0 w-1 ${replyingToDisplayName === displayName ? "bg-headPrimary" : "bg-headSecondary"}`}></div>

            <div className="w-[calc(100%-4px)] flex flex-col p-0.5 px-3 pr-4   ">

              <div className={`text-2xs font-bold ${replyingToDisplayName === displayName ? "text-headPrimary" : "text-headSecondary"} mr-2`}>
                {replyingToDisplayName}
              </div>

              <div className="text-sm truncate mt-1 ">{replyToMessage} </div>
            </div>
          </a>
        }

        {/* ------------------------| BOTTOM LINE: Message */}

        {
          quillEditorEnable ?
            <ReactQuill
              className='w-full'
              readOnly={true}
              theme={"bubble"}
              value={deleted ? "This Message was Deleted" : message} />
            :
            <p dangerouslySetInnerHTML={{ __html: deleted ? "This Message was Deleted" : message }} className={`dont-break-out text-base font-normal pt-1 lg:pt-2 text-gray-900 dark:text-white 
              ${deleted ? "text-red-600 italic" : ""} 
              ${himself ? " w-fit" : "w-full text-left"}`}>
            </p>
        }

        {!deleted && mediaType && mediaType === "img" && <div
          onClick={() => {
            setClickedImg(item)
            setShowImagePopup(true)
          }}
          className="max-w-[185px] pt-2 cursor-pointer">
          <img src={url} alt="" className='w-full h-auto object-cover bg-white' />
        </div>
        }
        {!deleted && mediaType && mediaType === "doc" &&
          <div className="w-full flex">
            <div
              onClick={() => {
                downloadURI(url, documentName)
              }}
              className="cursor-pointer w-full h-[50px] p-2 bg-white border border-gray-400 rounded-lg mt-1 flex items-center group">

              <div className="relative w-auto h-full ">

                <IoDocumentText className='h-full w-auto group-hover:opacity-50' />

                <div className="hidden group-hover:flex absolute top-0 bottom-0 left-0 right-0 m-auto items-center justify-center ">
                  <FiDownload className='w-8 h-8 text-headPrimary bg-lightPrimary p-1 rounded-md' />
                </div>
              </div>

              <div className="w-[calc(100%-50px)] pl-2 text-sm font-normal group-hover: h-full truncate">
                {documentName}
              </div>

            </div></div>
        }
      </div>

      {himself && <div className="w-9 h-9 lg:w-9 lg:h-9 rounded-r-xl flex items-center justify-center bg-lightSecondary shadow-right">
      </div>}


    </div>
  )
}

export default Chat